// extracted by mini-css-extract-plugin
export default {"message":"styles_message__WT4q3","info":"styles_info__9zCys","no-max-width":"styles_no-max-width__mjAYE","noMaxWidth":"styles_no-max-width__mjAYE"};